<div id="map" class="map" (dblclick)="getCoordinate($event)"></div>
